module.exports = __webpack_public_path__ + "static/media/community_room.33b07233.jpg";